import { FC, ReactNode, useEffect, useState } from "react";
import Icon from "../Icon";
import RenderWhen from "../RenderWhen";

import styles from "./extended-loading-message.module.scss";

type Props = {
  waitTime: number;
  title?: string;
  text: string | ReactNode;
  footer?: ReactNode;
};

const ExtendedLoadingMessage: FC<Props> = ({
  waitTime,
  title = "This analysis is taking longer than expected.",
  text,
  footer
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, waitTime);

    return () => clearTimeout(timer);
  }, [waitTime]);

  if (!isVisible) return null;

  return (
    <div
      className={styles.container}
      data-testid="extended_loading_message_container"
    >
      <div className={styles.iconContainer}>
        <Icon name="clock" className={styles.mainIcon} />
      </div>
      <h2 className={styles.title} data-testid="extended_loading_message_title">
        {title}
      </h2>
      <div
        className={styles.bodyText}
        data-testid="extended_loading_message_text"
      >
        {text}
      </div>
      <RenderWhen condition={!!footer}>
        <div className={styles.footer}>{footer}</div>
      </RenderWhen>
    </div>
  );
};

export default ExtendedLoadingMessage;
